export function getId(id: string): string {
  return id.split(":")[1] || id;
}
